import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'
import { RoutesFilters } from '@types'

import { routesApi } from './api'

const useRoutes = (filters?: RoutesFilters) => {
  const { data: routes, isLoading: isRoutesLoading } = useQuery(
    [QUERY_KEYS.ROUTES, { filters }],
    () => routesApi.getRoutes({ filters }),
  )

  const { data: routesFilters, isLoading: routesFiltersIsLoading } = useQuery(
    [QUERY_KEYS.ROUTES_FILTERS],
    () => routesApi.getRoutesFilters(),
    { staleTime: Infinity },
  )

  return {
    routesFilters,
    routes,
    isRoutesLoading,
    routesFiltersIsLoading,
  }
}

export { useRoutes }
